module.exports = __webpack_public_path__ + "static/media/programs.a96bbeb6.svg";